import types from './mutation-types';
import PersonService from '@/services/person-service.js';
import { isNil } from 'lodash';
import { CancelToken } from 'axios';

let autocompleteRequestSource = null;

const actions = {
    fetchAutocomplete({ commit }, query) {
        commit(types.FETCH_AUTOCOMPLETE_START);

        if(!isNil(autocompleteRequestSource)) {
            autocompleteRequestSource.cancel();
        }

        autocompleteRequestSource = CancelToken.source();

        PersonService.get({ query: query }, autocompleteRequestSource.token)
            .then(categories => {
                if(!isNil(categories)) {
                    commit(types.FETCH_AUTOCOMPLETE_SUCCESS, categories);
                }
            })
            .catch(error => commit(types.FETCH_AUTOCOMPLETE_ERROR));
    }
};

export default actions;



// WEBPACK FOOTER //
// ./src/store/modules/person/actions.js